import { render, staticRenderFns } from "./LegacyPage.vue?vue&type=template&id=01735661&"
import script from "./LegacyPage.vue?vue&type=script&lang=js&"
export * from "./LegacyPage.vue?vue&type=script&lang=js&"
import style0 from "./LegacyPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports